<template>
  <section>
    <div class="pop-room asset-detail-pop" v-if="assetDetail.status">
      <a href="javascript:;" @click="hidePop()" class="iconfont icon-close"></a>
      <div class="pop-cont">
        <el-tabs v-model="typeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="资产信息" name="info">

            <el-col :span="22" class="showDataDetail" v-if="assetInfo">
              <div class="tip">* 基本资料</div>
              <ul>
                <li class="w3">
                  <label>分类:</label>
                  <span>{{ getClassify(assetInfo) }}</span>
                </li>
                <li>
                  <label>资产编号:</label>
                  <span>{{assetInfo.number}}</span>
                </li>
                <li class="w2">
                  <label>资产名称:</label>
                  <span>{{assetInfo.name}}</span>
                </li>
                <li>
                  <label>资产属性:</label>
                  <span>{{ assetInfo.attribute.name }}</span>
                </li>
                <li>
                  <label>数量:</label>
                  <span>{{assetInfo.amount}}</span>
                </li>
                <li>
                  <label>购置金额(单价)(元):</label>
                  <span>{{assetInfo.price}}</span>
                </li>
                <li>
                  <label>购置时间:</label>
                  <span>{{assetInfo.purchaseTime}}</span>
                </li>
                <li>
                  <label>入库时间:</label>
                  <span>{{assetInfo.storageTime}}</span>
                </li>
                <li>
                  <label>入账时间:</label>
                  <span>{{assetInfo.rzTime}}</span>
                </li>
                <li>
                  <label>当前状态:</label>
                  <span v-html="getStatus(assetInfo.status)"></span>
                </li>

                <li>
                  <label>累计折旧:</label>
                  <span>{{ assetInfo.ljzj }}</span>
                </li>
                <li>
                  <label>当前净值:</label>
                  <span>{{ assetInfo.jz }}</span>
                </li>
                <li>
                  <label>残值:</label>
                  <span>{{ assetInfo.cz }}</span>
                </li>
                <li>
                  <label>折旧年限:</label>
                  <span>{{ assetInfo.zjnx }}</span>
                </li>

                <li>
                  <label>盘点情况:</label>
                  <span>
                    <strong v-if="assetInfo.panStatus==1" style="color:green">盘亏</strong>
                    <strong v-else-if="assetInfo.panStatus==0" style="color:red">盘盈</strong>
                    <strong v-else-if="assetInfo.panStatus==2">正常</strong>
                    <strong v-else>未登记</strong>
                  </span>
                </li>
              </ul>

              <div class="tip">* 规格型号属性</div>
              <ul>
                <li class="w2">
                  <label>厂商:</label>
                  <span>{{assetInfo.manufacturer}}</span>
                </li>
                <li>
                  <label>规格型号:</label>
                  <span>{{assetInfo.spec}}</span>
                </li>
                <li>
                  <label>证书编号:</label>
                  <span>{{assetInfo.certificateNum}}</span>
                </li>
                <li>
                  <label>证件号码:</label>
                  <span>{{assetInfo.zjhm}}</span>
                </li>
                <li>
                  <label>面积:</label>
                  <span>{{assetInfo.mj}}</span>
                </li>
                <li class="w2">
                  <label>供应商:</label>
                  <span>{{assetInfo.supplier?assetInfo.supplier.name:''}}</span>
                </li>
                <li>
                  <label>出厂日期:</label>
                  <span>{{assetInfo.ccTime}}</span>
                </li>
                <li>
                  <label>截止保修期:</label>
                  <span>{{assetInfo.bxTime}}</span>
                </li>
              </ul>

              <div class="tip">* 使用存放</div>
              <ul>
                <li>
                  <label>所属部门:</label>
                  <span>{{assetInfo.ownDept?assetInfo.ownDept.name:''}}</span>
                </li>
                <li class="w2">
                  <label>存放地点:</label>
                  <span>{{assetInfo.usePlace}}</span>
                </li>
                <li>
                  <label>使用人:</label>
                  <span>
                    {{assetInfo.user ? assetInfo.user.name : ""}}
                    <el-tag type="success" size="mini" v-if="assetInfo.syStatus==1">已确认</el-tag>
                    <el-tag type="danger" size="mini" v-if="assetInfo.syStatus==0">未确认</el-tag>
                  </span>
                </li>
                <li>
                  <label>责任人:</label>
                  <span>{{assetInfo.zrUser ? assetInfo.zrUser.name : ""}}
                    <el-tag type="success" size="mini" v-if="assetInfo.zrStatus==1">已确认</el-tag>
                    <el-tag type="danger" size="mini" v-if="assetInfo.zrStatus==0">未确认</el-tag>
                  </span>
                </li>
                <li>
                  <label>入库确认(财务):</label>
                  <span>{{assetInfo.cwUser ? assetInfo.cwUser.name : ""}}
                    <el-tag type="success" size="mini" v-if="assetInfo.cwStatus==1">已确认</el-tag>
                    <el-tag type="danger" size="mini" v-if="assetInfo.cwStatus==0">未确认</el-tag>
                  </span>
                </li>
                <li class="remark w3">
                  <label>备注:</label>
                  <span>{{assetInfo.remark}}</span>
                </li>
              </ul>

              <div class="tip" v-if="assetInfo.attachments.length">* 附件</div>
              <div class="clear pi-attach-arr" style="margin-top:0;" v-if="assetInfo.attachments.length">
                <div class="appendix">
                  <div class="item" v-for="item,i in assetInfo.attachments">
                    <i class="iconfont icon-link"></i>
                    <file-link :item="item"></file-link>
                    <a :href="item.fileUrl" style="margin-left:5px;" target="_blank">
                      <el-button size="mini">下载</el-button>
                    </a>
                  </div>
                </div>
              </div>
            </el-col>

            <div class="ball-loading" v-else>
              <div class="k-ball-holder3">
                <div class="k-ball7a"></div>
                <div class="k-ball7b"></div>
                <div class="k-ball7c"></div>
                <div class="k-ball7d"></div>
              </div>
            </div>

          </el-tab-pane>
          <el-tab-pane label="变更/维修记录" name="log">
            <log-list :assetId="assetInfo.id" v-if="typeName=='log'"></log-list>
          </el-tab-pane>
          <el-tab-pane label="二维码" name="qrcode">

            <div class="label-room">
              <div id="printQr" ref="printQr">
                <table class="print-table">
                  <tbody>
                    <tr class="firstRow">
                      <td colspan="3">
                        <p class="name">{{assetInfo.depName}}</p>
                        <p class="first-name">固定资产标牌</p>
                      </td>
                    </tr>
                    <tr>
                      <td width="80">
                        资产编号
                      </td>
                      <td colspan="2">
                        {{assetInfo.number}}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        资产名称
                      </td>
                      <td colspan="2">
                        {{assetInfo.name}}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        规格型号
                      </td>
                      <td width="180">
                        {{assetInfo.spec}}
                      </td>
                      <td rowspan="3" width="100">
                        <img :src="qrImgUrl" width="100" height="100" alt="" />
                      </td>
                    </tr>
                    <tr>
                      <td>
                        启用日期
                      </td>
                      <td>
                        {{assetInfo.purchaseTime}}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        存放地点
                      </td>
                      <td>
                        {{assetInfo.usePlace}}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <p>
              <el-button @click="print()" style="margin:10px;" type="primary" size="mini">打印标签纸</el-button>
            </p>

          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </section>
</template>


<script>
  import {
    mapState
  } from "vuex";

  import Qrcanvas from 'qrcanvas-vue';

  import LogList from './logList'
  import FileLink from '@/components/FileLink'
  export default {
    components: {
      LogList,
      Qrcanvas,
      FileLink,
    },
    computed: {
      ...mapState({
        assetDetail: state => state.asset.assetDetail,
      })
    },
    data() {
      return {
        attributeArr: ['自制', '采购', '租赁', '出租', '其他'],
        dataList: [],
        typeName: 'info',

        // 二维码
        options: {
          data: '',
          cellSize: 6,
          size: 6,
        },
        qrImgUrl: '',

        // 固定资产info
        assetInfo: ""
      }
    },
    created() {
      this.typeName = 'info'
    },
    mounted() {
      // console.log()
      this.setQr()
    },
    methods: {
      getStatus(status) {
        let statusName = ["闲置中", "使用中", "维修中", "正常报废", "非正常报废", "损毁", "出售", "其他", "盘盈", "盘亏"]
        return statusName[status]
      },
      print() {
        this.$print(this.$refs.printQr)
      },
      // 组装分类
      getClassify(data) {
        let _str = ""
        if (data.mClassify) {
          _str += data.mClassify.name + " / "
        }
        if (data.dClassify) {
          _str += data.dClassify.name + " / "
        }
        if (data.parentClassify) {
          _str += data.parentClassify.name + " / "
        }
        if (data.classify) {
          _str += data.classify.name
        }
        return _str
      },
      setQr() {
        console.log(this.assetDetail)
        let _asset_url = "/m/a/d/" + this.assetDetail.data.id

        this.options = Object.assign({}, this.options, {
          data: 'http://' + window.location.host + _asset_url,
        });

        this.qrImgUrl = axios.defaults.baseURL + '/common/url/convert/qrcode?url=' + 'http://' + window.location.host +
          _asset_url

      },
      handleClick() {},
      // 隐藏表单
      hidePop() {
        this.$store.commit('set_assetDetail', {
          status: false,
          data: {}
        })
      }
    },
    watch: {

      assetDetail: {
        handler(newName, oldName) {
          // 资产详情通过ID获取
          console.log(this.assetDetail.data.id)
          if (this.assetDetail.data.id) {
            // 获取资产详情
            ajax.get('/asset/info/' + this.assetDetail.data.id, '', (res) => {
              this.loading = false
              this.assetInfo = res.vo
            })
          }
          this.setQr()
        },
        deep: true
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/asset/assetDetail.vue